/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import {Link, Route} from "react-router-dom";
import {getTitleByPath, getTitleByRoute, PageRoutes} from "../../../../api/utils/aemEndpointUtil";
import DocumentTitle from "react-document-title";


const Breadcrumb = ({mapping}) => (
    <ol className="breadcrumb">
        <li>
            <Link to={'/'}>{getTitleByRoute(mapping, PageRoutes.myPuratos)}</Link>
        </li>
        <Route path='/:path' render={routeProps => <BreadcrumbItem {...routeProps} mapping={mapping}/>}/>
    </ol>
);

const BreadcrumbItem = ({match, mapping, ...rest}) =>
    <DocumentTitle
        title={`${getTitleByPath(rest.mapping, match.params.path) ? getTitleByPath(rest.mapping, match.params.path) : 'My Puratos'} - My Puratos`}>
        <React.Fragment>
            {match.isExact ?
                <li>
                    {getTitleByPath(rest.mapping, match.params.path)}
                </li>
                :
                <li>
                    <Link to={match.url || ''}>{getTitleByPath(rest.mapping, match.params.path)}</Link>
                </li>
            }
            <Route path={`${match.url}/:path`}
                   render={routeProps => <BreadcrumbItem {...routeProps} mapping={mapping}/>}/>
        </React.Fragment>
    </DocumentTitle>;

Breadcrumb.propTypes = {};
Breadcrumb.defaultProps = {};

export default Breadcrumb;
